import axios, { AxiosResponse } from 'axios';

import { EStavPozadavku } from 'enums/specialniSluzby/stavPozadavku';
import { ETypTransakce } from 'enums/specialniSluzby/typTransakce';

export interface ueSeznamPolozek {
    idpolozky: number;
    pocetcp: number;
    ucet: string;
    idnabyvatele: string;
    koducastnika: string;
    cislozastavnismlouvy: string;
    poznamka: string;
    zdrojdat: string;
    zpusobporizeni: string;
    typtransakce: ETypTransakce;
    upozorneni: string;
    idvcdcp: string;
    stav: EStavPozadavku;
    idvisb: string;
    uzivatel: string;
    meznidatumprozruseni: string;
    lzeevidovatod: string;
}

export interface IOvereniuctuGet {
    polozky: ueSeznamPolozek[];
    offset: number;
    limit: number;
    count: number;
    pocetcp: number;
    pocetuctu: number;
    order: string;
}

export interface IDataOvereniuctuGet {
    id?: number;
    idpolozky?: number | string;
    ucet?: string;
    idnabyvatele?: string;
    koducastnika?: string;
    zdrojdat?: string;
    zpusobporizeni?: string;
    idvcdcp?: string;
    typtransakce?: ETypTransakce;
    stav?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface IOvereniuctuPost {
    ucty: [
        {
            id: number;
            idpolozky: number;
            ucet: string;
            vysledekovereni: ['OVEREN'];
        }
    ];
}

interface IDataOvereniuctuPost {
    id?: number;
    idpolozky?: number | string;
    ucet?: string;
    idnabyvatele?: string;
    koducastnika?: string;
    zdrojdat?: string;
    zpusobporizeni?: string;
    idvcdcp?: string;
    typtransakce?: ETypTransakce;
    stav?: string;
}

/* Vrátí seznam požadavků k ověření účtu */
export const ueOvereniuctuGet = (id: number, data: IDataOvereniuctuGet) => {
    return axios({
        method: 'GET',
        url: `/UE/${id}/overeniuctu`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IOvereniuctuGet>) => resp.data);
};

/* Ověří účty */
export const ueOvereniuctuPost = (id: number, data: IDataOvereniuctuPost) => {
    return axios({
        method: 'POST',
        url: `/UE/${id}/overeniuctu`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse) => resp.data);
};
